<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :value.sync="compareType"/>
    <sFormItem
      v-if="$_showParametersWithOperator"
      class="parameters"
      prop="parameter"
      :rules="parametersRules">
      <sInput
        v-if="mode === 'String'"
        clearable
        data-qa="condition-props-int"
        :disabled="disabled"
        placeholder=""
        :value.sync="parameters"/>
      <sInputNumber
        v-else
        clearable
        data-qa="condition-props-number"
        :disabled="disabled"
        :placeholder="mode === 'Decimal' ? '0.00' : '0'"
        :precision="mode === 'Decimal' ? 2 : 0"
        :value.sync="parameter"/>
    </sFormItem>
  </div>
</template>
<script>
import Operator from 'components/automation/conditions/default/operator.vue'
import automations from 'mixins/automations.js'

/**
 * Компонент простого поля
 */
export default {
  name: 'SimpleField',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      parametersRules: {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          let isEmpty = !that.parameter
          if (!isEmpty && that.mode === 'String') {
            isEmpty = !that.parameter.trim()
          } else if (!isEmpty && (that.mode === 'Number' || that.mode === 'Decimal')) {
            isEmpty = !+that.parameter
          }

          if (isEmpty) {
            callback(new Error(that.$t('Validate.Required')))
          }
          callback()
        },
      },
    }
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        if (!this.$_showParametersWithOperator) {
          result.parameters = null
        }
        this.$emit('update:value', result)
      }
    },
    parameter: {
      get() {
        if (!this.value?.parameters) {
          return null
        }
        let parameters
        try {
          const parseParam = JSON.parse(this.value.parameters) || []
          parameters = Array.isArray(parseParam) ? parseParam[0] : null
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Tenders.ErrorConditionParams'),
            showClose: true,
            progress: true,
          })
          parameters = null
        }
        if (this.mode === 'Number' || this.mode === 'Decimal') {
          return +(parameters || '0')
        }
        return parameters
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)

        result.parameters = JSON.stringify([newValue])
        this.$emit('update:value', result)
      }
    },
  },
  watch: {
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameter = null
        }
      }
    }
  },
  components: {
    Operator
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    mode: {
      type: String,
      default: 'Number',
      validator: function (value) {
        const correct = ['Decimal', 'Number', 'String'].indexOf(value) !== -1
        return correct
      },
    },
    operators: {
      type: Array
    }
  },
}
</script>
<style scoped lang="scss">
.comparation,
.parameters {
  width: 300px;
  margin-top: 15px;
}
</style>
